import type { GuideGapReport, ReportSummary } from "@/types";
import { apiClient } from "./client";

export const reportService = {
  guideGaps: async (property_id: string, days: number): Promise<GuideGapReport> => {
    const { data } = await apiClient.get<GuideGapReport>("/admin/reports/guide-gaps", {
      params: { property_id, days },
    });
    return data;
  },
  summary: async (
    property_id: string,
    check_in: string,
    check_out: string
  ): Promise<ReportSummary> => {
    const { data } = await apiClient.get<ReportSummary>("/admin/reports/summary", {
      params: { property_id, check_in, check_out },
    });
    return data;
  },
};
